export default __webpack_public_path__ + "static/media/01C.010.13563dda.png";